import React, { useState } from 'react';
import axios from 'axios';
import { RefreshCw, CheckCircle, AlertTriangle } from 'lucide-react';

const OcrTestPage = () => {
  const [inputText, setInputText] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleNormalize = async () => {
    if (!inputText.trim()) return;
    setLoading(true);
    setError('');
    try {
      const apiBase = process.env.REACT_APP_API_BASE_URL || '';
      const chatApiUrl = apiBase.endsWith('/api') ? apiBase.replace('/api', '/api-chat') : 'http://localhost/api-chat';
      
      const response = await axios.post(`${chatApiUrl}/ocr/normalize`, {
        text: inputText,
        mode: 'safe'
      });
      setResult(response.data);
    } catch (err) {
      console.error(err);
      setError('Failed to reach OCR API. Make sure backend-chat is running on port 8000.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>OCR Normalization Test</h2>
      </div>

      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white">
              <h5 className="mb-0">Raw Input (from LocalParse/OCR)</h5>
            </div>
            <div className="card-body">
              <textarea
                className="form-control"
                rows="15"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder="Paste raw text here... (e.g. Tarnbahan lmbaran negara lentang UndangUndang)"
              />
              <button 
                className="btn btn-primary mt-3 w-100 d-flex justify-content-center align-items-center"
                onClick={handleNormalize}
                disabled={loading || !inputText.trim()}
              >
                {loading ? <RefreshCw className="animate-spin me-2" size={18} /> : 'Normalize Text'}
              </button>
              {error && <div className="alert alert-danger mt-3">{error}</div>}
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white">
              <h5 className="mb-0">Normalized Output</h5>
            </div>
            <div className="card-body">
              {result ? (
                <div>
                  <textarea
                    className="form-control mb-3 bg-light"
                    rows="8"
                    readOnly
                    value={result.content_clean}
                  />
                  <h6 className="mt-4 border-bottom pb-2">Corrections Log ({result.corrections.length})</h6>
                  {result.corrections.length > 0 ? (
                    <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                      <ul className="list-group list-group-flush">
                        {result.corrections.map((corr, idx) => (
                          <li key={idx} className="list-group-item px-0">
                            <div className="d-flex justify-content-between">
                              <span className="fw-bold text-danger text-decoration-line-through">{corr.original}</span>
                              <span className="fw-bold text-success">→ {corr.suggestion}</span>
                            </div>
                            <div className="small text-muted mt-1">
                              {corr.type === 'auto_fix' ? (
                                <span className="badge bg-success me-2"><CheckCircle size={12} className="me-1"/> Auto Fix</span>
                              ) : (
                                <span className="badge bg-warning text-dark me-2"><AlertTriangle size={12} className="me-1"/> Needs Review</span>
                              )}
                              Confidence: {(corr.confidence * 100).toFixed(0)}%
                            </div>
                            <div className="small text-muted mt-1">{corr.reason}</div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <p className="text-muted small">No corrections made.</p>
                  )}
                </div>
              ) : (
                <div className="d-flex h-100 justify-content-center align-items-center text-muted">
                  <p>Submit text to see normalized results.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OcrTestPage;
